/**
 * Legacy EntityApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.entityApi`) keep resolving.
 *
 * The actual EntityApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/entity/entity-api.service.ts
 */
angular.module("acme.common.service.entityApi", [
  "acme.common.factory.QueryStringBuilder",
  "acme.common.factory.apiVersion",
]);
